export const yesNoFilterFactory = () => (booleanValue: any) =>  booleanValue ? "Yes" : "No";



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/filter/yesNo.filter.ts